// Matches the font asset paths emitted by the build's fonts/[name] asset setting.
const FONT_FAMILY = '"Glacial Indifference", sans-serif';
const FONT_FACE_CSS = `
@font-face {
  font-family: "Glacial Indifference";
  src: url("/dist/fonts/GlacialIndifference-Regular.otf") format("opentype");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Glacial Indifference";
  src: url("/dist/fonts/GlacialIndifference-Bold.otf") format("opentype");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}`;

module.exports = { FONT_FAMILY, FONT_FACE_CSS };
